import React, { Component } from 'react';
import compose from 'recompose/compose';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Slider from 'infinite-react-carousel';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import Switch from '@material-ui/core/Switch';
import { Box, MenuItem, Select } from '@material-ui/core';

// Component styles
import styles from './styles';
import Availability from '../components/Availability';
import Percentage from './Percentage'
import ResponseTime from '../components/ResponseTime';
import Statistics from '../components/Statistics'
import PdfPeriodical from './PdfPeriodical'

import moment from 'moment'
import 'moment/locale/es'
import { autoRefreshSavedValue, autoRefreshTimeOptions, autoRefreshTimeSavedValue } from '../../../utils/local-storage/auto-refresh-monitoreos';
import { DateRangePicker } from '../../../components/DateRangePicker';
import { addDays, addYears } from 'date-fns';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class Periodical extends Component {
    constructor(props) {
        //console.log('props periodical', props.params.match.params.objetivo_id)
        //console.log(sessionStorage.getItem("listaObjetivosOnline"))
        var dataObjective=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
        var filterObjective=dataObjective.filter(data=>parseInt(data.objetivo_id)===parseInt(props.params.match.params.objetivo_id))
        filterObjective=(filterObjective[0])
        super(props);

        //this.myCallback = this.myCallback.bind(this);
        this.header=React.createRef();
        this.footer=React.createRef();
        this.docToPrint=React.createRef();
        this.docToPrint1=React.createRef();
        this.docToPrint2=React.createRef();
        this.docToPrint3=React.createRef();
        this.docToPrint4=React.createRef();
        this.docToPrint5=React.createRef();
        this.docToPrint6=React.createRef();
        this.docToPrint7=React.createRef();
        this.handleMainPeriodical = this.handleMainPeriodical.bind(this);
        this.state = {
            props: props,
            online:null,
            steps:filterObjective.Pasos,
            filter:true,
            years:[moment().year(),moment().subtract(1, 'years').year(),moment().subtract(2, 'years').year()],
            months:['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo','Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            selectMonth: '',
            indexMonth:moment().subtract(1,'months').month(),
            actualYear:moment().year(),
            schedule:0,
            loadPdf:false,
            autoRefresh: autoRefreshSavedValue,
            autoRefreshTime: autoRefreshTimeSavedValue,
            globalPeriodValue: "",
            globalStatePeriod: null,
            minDate: addYears(new Date(`${moment().year()}-01-01`), -2),
        }
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
    }

    handleMainPeriodical=(e)=>{
        this.setState({
            filter:true,
            loadPdf:false,
            pdfPeriodicalDiv:false
        })
    }

    handleShowOnline =(event)=>{
        this.props.handlePeriod()
    }



    SampleNextArrow=()=> {
        const {onClick}=this.props
            return (
            <ArrowForwardIosIcon
                style={{ display: "block", color: "grey" }}
            />
            )
    }

    SamplePrevArrow=()=> {
        const {onClick}=this.props
        return (
        <ArrowBackIosIcon
            style={{ display: "block", color: "grey" }}
        />
        );
    }

    handleShowTime=(event)=>{
        const selectMonth = event.currentTarget.id
        const indexMonth = this.state.months.indexOf(selectMonth)
        this.setState({
            selectMonth,
            indexMonth,
        })
        const year = String(this.state.actualYear)
        const month = String(indexMonth+1)
        const begin=(moment(year+'-'+month+'-01')._d)
        let final= (moment(begin).endOf('month')._d)
        if(moment().year()===this.state.actualYear & moment().month()===indexMonth){
            final=moment().add(-1,'days')._d
        }
        this.setState({globalPeriodValue: "custom", globalStatePeriod: {"startDate": begin, "endDate": final, key: "selection"}})
    }

    handleYear=(i, j)=>{
        const {years}=this.state
        if(i===years.length-1&j===0||i===years.length-2&&j===0){
            this.setState({
                actualYear:moment().year()
            })
        }else if(i===0&j===years.length-2||i===years.length-1&&j===years.length-2){
            this.setState({
                actualYear:moment().subtract(1, 'years').year()
            })
        }else if(i===years.length-2&j===years.length-1||i===0&&j===years.length-1){
            this.setState({
                actualYear:moment().subtract(2, 'years').year()
            })
        }
    }

    handleSchedule=(event)=>{
        this.setState({
            schedule:event.currentTarget.id,
        })
    }

    load=(e)=>{
        if (this.state.selectMonth === ""){
            toast.error(this.translation('online-periodical.error.select-period'))
            return
        }
        if(e.currentTarget.value==="pdf"){
            this.setState({
                filter:false,
                pdfPeriodicalDiv:true,
                loadPdf:true
            })
        }else if(e.currentTarget.value==="main"){
            this.setState({
                filter:true,
                pdfPeriodicalDiv:false
            })
        }else{
            this.setState({
                filter:false,
                pdfPeriodicalDiv:false
            })
        }
    }

    createPdf=()=>{
        var nameObj=this.props.params.match.params.nombre_objetivo+"-Periodicos.pdf"
        const input0 = this.docToPrint.current;
        const input1 = this.docToPrint1.current;
        const input2 = this.docToPrint2.current;
        const input3 = this.docToPrint3.current;
        const input4 = this.docToPrint4.current;
        const input5 = this.docToPrint5.current;
        const input6 = this.docToPrint6.current;
        const input7 = this.docToPrint7.current;
        let data = this.header.current
        let footer = this.footer.current;
        //console.log(data)
        data.style.display="inline"
        footer.style.display="inline"
        //console.log(data)
        var list=[data, input0, input1, input2, input3, input4, input5, input6, input7, footer]
        var namesList=['Disponibilidad Consolidada','Tiempo de Respuesta Consolidado','Disponibilidad Distribución Porcentual','Disponibilidad Resumen','Distribucion Porcentual por Paso','Disponibilidad Downtime Global Por Paso','TIEMPO DE RESPUESTA: POR DÍA DE LA SEMANA','Disponibilidad Frecuencia Absoluta']
        var doc = new jsPDF();
        const tasks = list.map(tab => html2canvas(tab))

        Promise.all(tasks).then(canvases =>{
            var cont=0
            var header=canvases[0]
            var footer=canvases[canvases.length-1]
            canvases.shift()
            canvases.pop()
            for (const canvas of canvases){
                var left=20
                var up=3
                var right=160
                var down= 30
                const imgData0 = header.toDataURL('image/png');
                doc.addImage(imgData0, 'PNG', left, up, right, down);//header
                doc.addFont("Roboto", "Helvetica", "Arial", "sans-serif");
                doc.setFont("Roboto", "Helvetica", "Arial", "sans-serif");
                doc.setFontSize(14);
                doc.setTextColor(100);
                doc.text(20, 50, namesList[cont]);//nombre componente
                up=70
                down=140
                const imgDataI = canvas.toDataURL('image/png');

                doc.rect(left, up, 160, down); // cuadrado componente

                doc.addImage(imgDataI, 'PNG', 20.2, 70.2, 159.5, 139.7);//componente
                up=260
                down=30
                left=0
                right=185
                const imgData1 = footer.toDataURL('image/png');
                doc.addImage(imgData1, 'PNG', left, up, right, down);//footer
                if(cont!==(canvases.length-1)){
                    doc.addPage();
                }
                cont++
            }


            doc.save(nameObj);
            this.setState({
                loadPdf:false,
            })
        })
        data.style.display="none"
        footer.style.display="none"
    }

    setCloseModal=()=>{
        this.setState({
            loadPdf:false,
        })
    }

    handleChangeAutoRefresh = () => {
        this.setState((prevState) => ({
            autoRefresh: !prevState.autoRefresh
        }))
        localStorage.setItem('autoRefreshMonitoreos', !this.state.autoRefresh)
    }

    changeAutoRefreshTimeValue = (event) => {
        const value = event.target.value
        this.setState({autoRefreshTime: value})

        localStorage.setItem('autoRefreshTimeValue', value)
    }

    changeGlobalPeriod = ({ value, statePeriod }) => {
        this.setState({globalPeriodValue: value, globalStatePeriod: statePeriod})
    }


    render() {    
        const t = this.props.t;
        const {filter, months, updateCount, index, selectMonth, indexMonth, actualYear, schedule, loadPdf, pdfPeriodicalDiv}=this.state
        const {classes}=this.props
        const horarios=(JSON.parse(sessionStorage.getItem("horarios")))
        const settings={slidesPerRow: 1, nextArrow: this.SampleNextArrow(),
            prevArrow: this.SamplePrevArrow(),
            beforeChange:(oldIndex, newIndex) =>this.handleYear(oldIndex, newIndex),
            //customPaging:(i)=>console.log(i)
        }
        if(filter===true){
            return (
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Button style={{backgroundColor: 'white', width:"100%"}} onClick={this.handleShowOnline} variant="outlined" size="small">
                            <Typography variant="button"> {t('online-periodical.button.back-to-online')} </Typography>
                        </Button>
                    </Grid>
                    {!Boolean(this.state.globalStatePeriod) &&
                    <Grid
                        item
                        sm={12}
                        md={6}
                        xl={6}
                        style={{textAlign:"center"}}
                    >
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center", padding:"0px"}}
                            >
                                <Typography style={{color:"#3b3b3b", fontWeight: 'bold'}}>{t('online-periodical.select-period.title')}</Typography>
                            </Grid>
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center", backgroundColor:"white", borderRadius: 3, marginTop: 10}}
                            >
                                <Slider { ...settings }>
                                    {this.state.years.map(years=>(

                                        <div>
                                            <div style={{fontWeight: 300, color:"#39424c", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight:"bold"}}>{years}</div>
                                        </div>
                                    ))}
                                </Slider>
                            </Grid>
                            {months.map((month, index)=>(
                                month==selectMonth?
                                <Grid
                                    item
                                    sm={6}
                                    md={3}
                                    xl={3}
                                    style={{textAlign:"center", padding:"0px"}}
                                >
                                    <Button id={month} style={{backgroundColor: '#0B1738', width:"100%" ,height: '100%', color:'#FFF'}} onClick={this.handleShowTime} variant="outlined"  size="small">
                                        <Typography variant="button"> {t(`online-periodical.select-period.months.${index + 1}`)} </Typography>
                                    </Button>
                                </Grid>
                                :
                                <Grid
                                    item
                                    sm={6}
                                    md={3}
                                    xl={3}
                                    style={{textAlign:"center", padding:"0px"}}
                                >
                                    <Button disabled={this.state.actualYear == moment().year() && moment(addDays(new Date(), -1)).month() < index} id={month} style={{backgroundColor: 'white', width:"100%"}} onClick={this.handleShowTime} variant="outlined"  size="small">
                                        <Typography variant="button" style={{ fontSize: '130%'}}> {t(`online-periodical.select-period.months.${index + 1}`)} </Typography>
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    }
                    {Boolean(this.state.globalStatePeriod) &&
                        <Grid item sm={12} md={6} lg={6} style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                            <Box marginBottom={'10px'}>
                                <Typography style={{color:"#3b3b3b", fontWeight: 'bold'}}>{t('online-periodical.select-period.date-range.title')}</Typography>
                            </Box>
                            <Box style={{ width: "fit-content", backgroundColor: "white", borderRadius: 5 }} paddingBottom={1}>
                                <DateRangePicker
                                    changePeriodFn={this.changeGlobalPeriod}
                                    dateRangeFromParent={this.state.globalStatePeriod}
                                    minDate={this.state.minDate}
                                    maxDate={addDays(new Date(), -1)}
                                />
                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() => {
                                        this.setState({ globalPeriodValue: "", globalStatePeriod: null })
                                    }} style={{ marginTop: 2 }}>
                                        {t('online-periodical.select-period.date-range.button.back-to-month-selection')}
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    }
                    <Grid
                        item
                        sm={12}
                        md={6}
                        xl={6}
                        style={{textAlign:"center"}}
                    >
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center", padding:"0px", marginBottom: 10}}
                            >
                                <Box>
                                    <Typography style={{color:"#3b3b3b", fontWeight: 'bold'}}>{t('online-periodical.select-schedule')}</Typography>
                                </Box>
                            </Grid>

                            {horarios.map(horario=>(
                                horario.horario_id==schedule?
                                <Grid
                                    item
                                    sm={6}
                                    md={3}
                                    xl={3}
                                    style={{textAlign:"center", padding:"0px"}}
                                >
                                    <Button id={horario.horario_id} style={{backgroundColor: '#0B1738', width:"100%", color:'#FFF'}} onClick={this.handleSchedule} variant="outlined"  size="small">
                                        <Typography variant="button" style={{ fontSize: '130%'}}> {horario.nombre} </Typography>
                                    </Button>
                                </Grid>
                                :
                                <Grid
                                    item
                                    sm={6}
                                    md={3}
                                    xl={3}
                                    style={{textAlign:"center", padding:"0px"}}
                                >
                                    <Button id={horario.horario_id} style={{backgroundColor: 'white', width:"100%"}} onClick={this.handleSchedule} variant="outlined"  size="small">
                                        <Typography variant="button" style={{ fontSize: '130%'}}> {horario.nombre} </Typography>
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={6}
                        xl={6}
                        style={{textAlign:"center"}}
                    >
                        <Button value="pdf" style={{backgroundColor: '#FF8B32', width:"50%", color:'white'}} onClick={this.load} variant="outlined" size="small">
                            <Typography variant="button">{t('online-periodical.button.export-to-pdf')}</Typography>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={6}
                        xl={6}
                        style={{textAlign:"center"}}
                    >
                        <Button value="" style={{backgroundColor: '#FF8B32', width:"50%", color:'white'}} onClick={this.load} variant="outlined"  size="small">
                            <Typography variant="button">{t('online-periodical.button.go-to-periodic-reports')}</Typography>
                        </Button>
                    </Grid>                    
                </Grid>
            )
        }
        else if(pdfPeriodicalDiv===true){
            return(
                <PdfPeriodical
                    params={this.props} schedule={schedule} periodical={true}
                    year={actualYear} month={selectMonth} indexMonth={indexMonth}
                    period="c" handleMainPeriodical={this.handleMainPeriodical}
                    globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod}
                />
            )
        }
        else{            
            return (
                <Grid
                    container
                    spacing={1}
                    justify='flex-end'
                >

                    <Grid
                        item
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}

                    >
                        <Button value="main" style={{backgroundColor: 'white', width:"100%"}} onClick={this.load} variant="outlined" color="primary" size="small">
                            <Typography variant="button">{t('online-periodical.button.go-back-to-periodic-reports-filter')}</Typography>
                        </Button>
                    </Grid>
                    <Grid item sm={12} md={4} lg={4} xl={4}>
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <Switch checked={this.state.autoRefresh} onChange={this.handleChangeAutoRefresh} style={{margin: 0}} color='primary' />
                                <Typography style={{marginLeft: 10, color: '#66788A'}} variant='h6'>{t('text.auto-refresh')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item lg={12}>
                                <Select
                                    labelId='select-time-refresh-label'
                                    id='select-time-refresh'
                                    label={t('online-periodical.select.refresh-interval.label')}
                                    value={this.state.autoRefreshTime}
                                    onChange={this.changeAutoRefreshTimeValue}
                                    fullWidth
                                >
                                    {autoRefreshTimeOptions.map(({label, value}) => {
                                        return(
                                            <MenuItem key={label} value={value}>{label}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/*AvailabilityConsolidated*/}
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        ref={this.docToPrint}
                    >
                        <Availability refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodicalView = {true}  periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={7} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                        ref={this.docToPrint1}
                    >
                       <ResponseTime refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.response-time')} period="c" id="availability-h" typePeriod={3} typeGraph={0} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                        ref={this.docToPrint2}
                    >
                       <Availability refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={4} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                        ref={this.docToPrint3}
                    >
                       <Availability refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={9} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                        ref={this.docToPrint4}
                    >
                        <Percentage  periodical={true} schedule={schedule} year={actualYear} month={selectMonth} indexMonth={indexMonth} title="" period="c" typeGraph={0} steps={this.state.steps} isStep={true} indexStep={0} globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                        </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        ref={this.docToPrint5}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                    >
                       <Availability refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodicalView={true} periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={6} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>

                    {/* TABLA Disponibilidad Downtime Global*/}
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                    >
                        <Availability refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodicalView = {true}  periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={10} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    {/*ResponseWeekDay - ResponseTimeGeneralDay*/}
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        ref={this.docToPrint6}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                    >
                       <Percentage periodical={true} schedule={schedule} year={actualYear} month={selectMonth} indexMonth={indexMonth} title="" period="c" typeGraph={1} steps={this.state.steps} globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod}/>
                    </Grid>
                    {/*AbsoluteFrecuency*/}
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        ref={this.docToPrint7}
                        //style={{height:"0px"}}
                        //style={{border: "1px solid rgb(204, 204, 204)"}}
                    >
                       <Statistics refreshTime={this.state.autoRefreshTime} params={this.props} schedule={schedule} periodical={true} year={actualYear} month={selectMonth} indexMonth={indexMonth} title={t('online.graph.availability-gauge.availability')} period="c" id="availability-h" typePeriod={3} typeGraph={0} automaticUpdate={this.state.autoRefresh} size="90%" textSize="25" dataLabelsY="-35" globalPeriodValue={this.state.globalPeriodValue} globalStatePeriod={this.state.globalStatePeriod} />
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center", display:"none"}}
                        ref={this.header}                                    
                    >   
                        <img style={{width:"100%"}}  src='/images/header_pdf.png' />
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center",display:"none"}}
                        ref={this.footer}                                    
                    >   
                        <img style={{width:"100%"}}  src='/images/footer_pdf.png' />
                    </Grid>
    
                </Grid>
                
            );
        }

    }

}


export default compose(withWidth(), withStyles(styles), withTranslation())(Periodical);